import React, { useEffect } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { customerBillingList } from "../../actions/shipmentNPayment";
import Table from "../../common/Table";
import { amountFormat } from "../../config/helper";

const UpcomingPayments = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const billing_list = useSelector(
    (state) => state?.shipNPay?.customer_billing_list
  );

  useEffect(() => {
    let obj = {
      email: localStorage.getItem("email"),
    };
    dispatch(customerBillingList(obj));
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      header: "Invoice No",
      accessor: "InvoiceNo",
      width: 20,
    },
    {
      header: "Invoice Date",
      accessor: "BillingDate",
      width: 20,
      cell: (row) => (
        <span>{moment(row.BillingDate, "YYYYMMDD").format("MM/DD/YY")}</span>
      ),
    },
    {
      header: "Due Date",
      width: 20,
      accessor: "BillingDueDate",
      cell: (row) => (
        <span>
          {moment(row.BillingDueDate, "YYYYMMDD").format("MM/DD/YY")}
        </span>
      ),
    },
    {
      header: "Shipment ID",
      accessor: "ShipNo",
      width: 20,
    },
    {
      header: "Total Amount",
      accessor: "BillingNetValue",
      width: 20,
      cell: (row) => <span>$ {amountFormat(row.BillingNetValue)}</span>,
    },
  ];

  return (
    <div className="tb2">
      <div className="flex-between mb1">
        <label>Pending Payments</label>
        <span
          className="cursor view-all"
          onClick={() => {
            history.push("/payments");
          }}
        >
          VIEW ALL
        </span>
      </div>
      <Table
        columns={columns}
        loading={billing_list?.loading}
        style={{ margin: 0 }}
        data={
          billing_list?.data && Array.isArray(billing_list?.data?.billing_list)
            ? billing_list?.data?.billing_list
                ?.filter((ele) => ele.InvoiceClearing === "A")
                ?.slice(0, 5)
            : []
        }
        onRowClick={(row) => {
          history.push("/payment-doc/" + row?.InvoiceNo, {
            order_no: row?.OrderId,
            time: moment(row?.SoDate, "YYYYMMDD").format("DD MMM, YYYY"),
            billNo: row?.InvoiceNo,
          });
        }}
      />
    </div>
  );
};

export default UpcomingPayments;
